export default __webpack_public_path__ + "static/media/mobile_phone.9eba5fb7.svg";